import { Container } from 'unstated';
import { isEmpty, isNumeric } from 'validator';
import { validateEmptyLanguageObject } from '../../../helpers/Validations/validateEmptyLanguageObject';
import { validateIncompleteLanguageObject } from '../../../helpers/Validations/validateIncompleteLanguageObject';
import { validateEmptyValue } from '../../../helpers/Validations/validateEmptyValue';

export interface IBannerDetailState {
  banner: GQL.IBanner;
  errors: IValidationErrors;
  warnings: IValidationWarnings;
  languages: Array<GQL.ILanguage>;
  currentLanguage: string;
}

export interface IBannerDetailStateProps {
  banner: GQL.IBanner;
  languages: Array<GQL.ILanguage>;
}

export interface IValidationErrors {
  file: string | undefined;
  name: string | undefined;
  type: string | undefined;
}

export interface IValidationWarnings {
  file: string | undefined;
  type: string | undefined;
}

export class StateContainer extends Container<IBannerDetailState> {

  constructor(props: IBannerDetailStateProps) {
    super();

    this.state = {
      banner: props.banner,
      errors: {} as IValidationErrors,
      warnings: {} as IValidationWarnings,
      languages: props.languages,
      currentLanguage: props.languages.map(l => l.value)[ 0 ]
    };

    this.preValidate();
  }

  public async preValidate() {
    if (this.state.banner.id != undefined) {
      // await this.validateField('title', 'language');
    }
  }

  public async onChange(key: string, val: any, validate?: boolean, language?: string) {
    const method = { ...this.state.banner };

    if (language) {
      await this.setState({
        banner: { ...method, [ key ]: { ...this.state.banner[ key ], [ language ]: val } }
      });
    } else {
      await this.setState({ banner: { ...method, [ key ]: val } });
    }

    if (validate) {
      await this.validateField(key, language ? 'language' : 'regular');
    }
  }

  public async validate(): Promise<IValidationErrors> {
    const { banner } = this.state;
    const errors = { ...this.state.errors };

    const message = 'This field is required';

    const validateEmpty = (input: string | any) => {
      if (input == undefined || isEmpty(input)) {
        return message;
      } else {
        return undefined;
      }
    };

    // errors.file = validateEmpty(banner.file);
    errors.name = validateEmpty(banner.name);
    errors.type = validateEmpty(banner.type);

    await this.setState({ errors });
    return errors;
  }

  private async validateField(fieldName: string, type: 'language' | 'regular') {
    const { banner } = this.state;

    if (type == 'language') {
      const messageForEmpty = validateEmptyLanguageObject(banner[ fieldName ], 'This field is required');
      if (messageForEmpty) {
        await this.setState({ errors: { ...this.state.errors, [ fieldName ]: messageForEmpty } });
        return;
      }

      const messageForIncomplete = validateIncompleteLanguageObject(
        banner[ fieldName ],
        this.state.languages.map(l => l.value),
        'Not all languages are filled'
      );

      await this.setState({
        warnings: {
          ...this.state.warnings,
          [ fieldName ]: messageForIncomplete
        },
        errors: { ...this.state.errors, [ fieldName ]: messageForEmpty }
      });
    } else {
      const message = validateEmptyValue(banner[ fieldName ], true);
      await this.setState({
        errors: { ...this.state.errors, [ fieldName ]: message }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Banners/BannersDetail/StateContainer.ts